<template lang="">
    <div>
            <TopHeader2 underlineItem="گالری تصاویر"></TopHeader2>
            <section class="logo-header-resp d-md-none my-5">
                <div class="mx-auto">
                      <img src="@/assets/images/logos/logoBlack.png" alt="" />
                </div>
            </section>
             <main v-if="dataPage" class="main">
                 <div v-html="dataPage.body">

                  </div>
            </main>
            <loader v-else />

    </div>
</template>
<script>

import loader from "@/components/loader.vue";

import TopHeader2 from "../components/TopHeader2";
export default {
    components: {
        TopHeader2,loader
    },
    mounted() {
this.$axios.get("pages?pageId="+this.$route.params.id).then(response=>{
    this.dataPage=response.data.page
})
    },
    data(){
        return{
            dataPage:null
        }
    },
     metaInfo() {
    return {
      title:this.dataPage?this.dataPage.meta_title:"صفحه",
      meta: [
        {
          name: "description",
          content:this.dataPage?this.dataPage.meta_description:""
        },
      ]
    };
  },
}
</script>
<style scoped>
    .main{
        margin: 10% 5% 5%;
    }
</style>